import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import Loading from '../../../shared/components/custom/Loading';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';
import { formatDateTime } from '../../../util/date-and-time';

const SCORE_TYPE_LABELS = {
  goal: 'scoreTypeGoal',
  point: 'scoreTypePoint',
  attendant: 'scoreTypeAttendant',
  holeInOne: 'scoreTypeHoleInOne',
  medal: 'scoreTypeMedal',
};

const GamesListPage = ({ planId }) => {
  const [games, setGames] = useState([]);
  const [loadingGames, setLoadingGames] = useState(true);

  const p = partial('goalSponsor');
  const s = partial('shared');

  const fetchGames = async () => {
    setLoadingGames(true);
    try {
      const resGames = await Api.goalSponsor.games.getGames(planId);
      setGames(resGames);
      setLoadingGames(false);
    } catch (err) {
      toast.error(err || `${p('gamesRetrievingERROR')}`);
      setLoadingGames(false);
    }
  };
  useEffect(() => {
    fetchGames();
  }, []);

  const formatScore = (game) => {
    const typeKey = SCORE_TYPE_LABELS[game.scoreType] || SCORE_TYPE_LABELS.goal;
    return `${game.goalCount} ${p(typeKey)}`;
  };

  const renderGames = () => {
    return games.map((game, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`game-${game.id}`}
      >
        <td>
          <div className="flex-Vcenter">
            <Link to={`/goal-sponsor/games/edit/${planId}/${game.id}`}>
              {game.title}
            </Link>
          </div>
        </td>

        <td>{formatDateTime(game.startDate)}</td>
        <td>
          <b>{formatScore(game)}</b>
        </td>
        <td>
          <UncontrolledDropdown className="dashboard__table-more">
            <DropdownToggle>
              <DotsHorizontalIcon />
            </DropdownToggle>
            <DropdownMenu className="dropdown__menu">
              <Link to={`/goal-sponsor/games/edit/${planId}/${game.id}`}>
                <DropdownItem>{s('edit')}</DropdownItem>
              </Link>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));
  };

  return (
    <Container>
      <Loading loading={loadingGames} />
      <Row>
        <Col>
          <div className="float-right marginTop-0">
            <Link to={`/goal-sponsor/games/create/${planId}`}>
              <Button size="sm" color="primary">
                {p('createGame')}
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              paddingBottom: 5,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
            }}
          >
            <Table responsive striped>
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('title')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('date')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{p('score')}</div>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>{renderGames()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default GamesListPage;
